// Angular
import { Routes } from '@angular/router';

// Guards
import { authenticatedGuard } from './guards/authenticated.guard';
import { authGuard } from './guards/auth.guard';
import { adminGuard } from './guards/admin.guard';
import { menuGuard } from './guards/menu.guard';

// Componentes

// Main
import { MainComponent } from './componentes/main/main.component';
import { PrincipalComponent } from './componentes/main/principal/principal.component';

// Cartera
import { MicarteraComponent } from './paginas/cartera/micartera/micartera.component';
import { ProduccionComponent } from './paginas/cartera/produccion/produccion.component';
import { CancelacionesComponent } from './paginas/cartera/cancelaciones/cancelaciones.component';
import { RenovacionesComponent } from './paginas/cartera/renovaciones/renovaciones.component';

// Cotizadores
import { CotizadoresComponent } from './paginas/cotizadores/cotizadores.component';

// Pagos
import { CambiarContrasenaComponent } from './paginas/cambiar-contrasena/cambiar-contrasena.component';
import { RecibosComponent } from './paginas/pagos/recibos/recibos.component';
import { AntiguedadComponent } from './paginas/pagos/antiguedad/antiguedad.component';
import { EstadosComponent } from './paginas/pagos/estados/estados.component';
import { PagosOnlineComponent } from './paginas/pagos/pagos-online/pagos-online.component';

// Reclamaciones
import { ComisionesComponent } from './paginas/comisiones/comisiones.component';
import { ReclamosComponent } from './paginas/reclamaciones/reclamos/reclamos.component';
import { SinestralidadComponent } from './paginas/reclamaciones/sinestralidad/sinestralidad.component';
import { AccidentesComponent } from './paginas/reclamaciones/accidentes/accidentes.component';

// Menu-info
import { ContactosComponent } from './paginas/menu-info/contactos/contactos.component';
import { BuzonComponent } from './paginas/menu-info/buzon/buzon.component';
import { DocumentosComponent } from './paginas/menu-info/documentos/documentos.component';
import { AdministradorComponent } from './paginas/menu-info/administrador/administrador.component';
import { ImpresionMarbetesComponent } from './paginas/utilitarios/impresion-marbetes/impresion-marbetes.component';
import { DescargasComponent } from './paginas/utilitarios/descargas/descargas.component';
import { TalleresAfiliadosComponent } from './paginas/utilitarios/talleres-afiliados/talleres-afiliados.component';
import { ReembolsosComponent } from './paginas/reclamaciones/reembolsos/reembolsos.component';
import { MiPerfilComponent } from './paginas/mi-perfil/mi-perfil.component';
import { RentCarAfiliadosComponent } from './paginas/utilitarios/rent-car-afiliados/rent-car-afiliados.component';

export const routes: Routes = [
  {
    path: 'iniciar-sesion',
    loadChildren: () =>
      import('./componentes/login/login.routes').then((m) => m.LOGIN_ROUTES),
    canActivate: [authenticatedGuard],
  },
  {
    path: 'inicio',
    component: MainComponent,
    children: [
      // Main
      {
        path: '',
        component: PrincipalComponent,
      },
      {
        path: 'perfil',
        component: MiPerfilComponent,
      },
      {
        path: 'cambiar-contrasena',
        component: CambiarContrasenaComponent,
      },

      //Cartera
      {
        path: 'micartera',
        component: MicarteraComponent,
        canActivate: [menuGuard],
      },
      {
        path: 'produccion',
        component: ProduccionComponent,
        canActivate: [menuGuard],
      },
      {
        path: 'cancelaciones',
        component: CancelacionesComponent,
        canActivate: [menuGuard],
      },
      {
        path: 'renovaciones',
        component: RenovacionesComponent,
        canActivate: [menuGuard],
      },

      //Cotizadores
      {
        path: 'cotizaciones',
        component: CotizadoresComponent,
        canActivate: [menuGuard],
      },

      //Pagos
      {
        path: 'recibos',
        component: RecibosComponent,
        canActivate: [menuGuard],
      },
      {
        path: 'antiguedad',
        component: AntiguedadComponent,
        canActivate: [menuGuard],
      },
      {
        path: 'estados',
        component: EstadosComponent,
        canActivate: [menuGuard],
      },
      {
        path: 'pagos-online',
        component: PagosOnlineComponent,
        canActivate: [menuGuard],
      },

      //Reclamaciones
      {
        path: 'reclamos',
        component: ReclamosComponent,
        canActivate: [menuGuard],
      },
      {
        path: 'sinestralidad',
        component: SinestralidadComponent,
        canActivate: [menuGuard],
      },
      {
        path: 'accidentes',
        component: AccidentesComponent,
        canActivate: [menuGuard],
      },
      {
        path: 'reembolsos',
        component: ReembolsosComponent,
        canActivate: [menuGuard],
      },

      // Utilitarios
      {
        path: 'impresion-marbetes',
        component: ImpresionMarbetesComponent,
        canActivate: [menuGuard],
      },

      {
        path: 'descargas',
        component: DescargasComponent,
        canActivate: [menuGuard],
      },
      {
        path: 'talleres-afiliados',
        component: TalleresAfiliadosComponent,
        canActivate: [menuGuard],
      },
      {
        path: 'rent-car-afiliados',
        component: RentCarAfiliadosComponent,
        canActivate: [menuGuard],
      },

      //Comisiones
      {
        path: 'comisiones',
        component: ComisionesComponent,
        canActivate: [menuGuard],
      },

      // Menu-info
      {
        path: 'contactos',
        component: ContactosComponent,
      },
      {
        path: 'documentos',
        component: DocumentosComponent,
      },
      {
        path: 'admin',
        component: AdministradorComponent,
        canActivate: [authGuard, adminGuard],
      },
      {
        path: 'buzon',
        component: BuzonComponent,
      },
    ],
    canActivate: [authGuard],
  },
  { path: '**', redirectTo: 'iniciar-sesion', pathMatch: 'full' }, // Redirige la ruta vacía a login
];
